import api from "./api";

const editLectureService = {
  getDepartmentSchedule: (params) =>
    api.get("/edit-lecture/department-schedule", { params }),

  createEditOverride: (body) => api.post("/edit-lecture/override", body),

  updateEditOverride: (id, body) => api.put(`/edit-lecture/override/${id}`, body),

  deleteEditOverride: (id) => api.delete(`/edit-lecture/override/${id}`),

  getEditOverrideHistory: (params) =>
    api.get("/edit-lecture/history", { params }),
};

export default editLectureService;
